import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SlidersHorizontal, X } from "lucide-react";
import { colorOf } from "@/lib/colors";

export const DEFAULT_FILTERS = { day: "all", employee: "all", status: "all" };

const FilterSelect = ({ testId, value, onChange, children, placeholder }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="h-10 w-full rounded-xl bg-white sm:w-44">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>{children}</SelectContent>
  </Select>
);

export const FiltersBar = ({ filters, setFilters, employees, days, showDay }) => {
  const set = (key) => (v) => setFilters((f) => ({ ...f, [key]: v }));
  const active = filters.employee !== "all" || filters.status !== "all" || (showDay && filters.day !== "all");

  return (
    <div data-testid="filters-bar" className="filters-bar">
      <span className="hidden items-center gap-2 text-sm font-medium text-slate-600 sm:inline-flex">
        <SlidersHorizontal className="h-4 w-4" /> Filtri
      </span>
      {showDay && (
        <FilterSelect testId="filter-day" value={filters.day} onChange={set("day")}>
          <SelectItem value="all">Tutti i giorni</SelectItem>
          {days.map((d) => (
            <SelectItem key={d.idx} value={String(d.idx)}>{d.name} {d.label}</SelectItem>
          ))}
        </FilterSelect>
      )}
      <FilterSelect testId="filter-employee" value={filters.employee} onChange={set("employee")}>
        <SelectItem value="all">Tutti i dipendenti</SelectItem>
        {employees.map((e) => (
          <SelectItem key={e.id} value={e.id}>
            <span className="inline-flex items-center gap-2">
              <span className="h-2 w-2 rounded-full" style={{ background: colorOf(e).accent }} />
              {e.name}
            </span>
          </SelectItem>
        ))}
      </FilterSelect>
      <FilterSelect testId="filter-status" value={filters.status} onChange={set("status")}>
        <SelectItem value="all">Tutti gli stati</SelectItem>
        <SelectItem value="todo">Da fare</SelectItem>
        <SelectItem value="done">Completate</SelectItem>
        <SelectItem value="late">In ritardo</SelectItem>
      </FilterSelect>
      {active && (
        <button
          type="button"
          data-testid="filters-reset"
          onClick={() => setFilters((f) => ({ ...DEFAULT_FILTERS, day: showDay ? "all" : f.day }))}
          className="inline-flex h-10 items-center gap-1 rounded-xl px-3 text-sm text-slate-600 hover:bg-slate-100"
        >
          <X className="h-4 w-4" /> Azzera
        </button>
      )}
    </div>
  );
};
